import React, {useContext, useState} from "react"
import {navigate} from "gatsby"
import _ from "lodash"
import moment from "moment"
import nl2br from "react-nl2br"
import {ModdApi} from "../../libraries/modd"
import LoginImg from "../../images/Header/login.svg"
import CartImg from "../../images/Main/cart.svg"
import AuthContext from "../Context/AuthContext"
import CartContext from "../Context/CartContext"
import {getCookieSess} from "../Context/AuthProvider"
import {getFcSession, getFcMemberType, deleteFcSession} from "../Context/FcProvider"

const buttonLogin = (memberList, location) => {
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${LoginImg})`,
    backgroundSize: "18px",
  }

  let text = ""

  if (_.includes(memberList, "FREE")) {
    text = <span>一般販売商品<br/>（購入の手続きへ）</span>
    style.backgroundColor = "var(--label-free)"
  } else if (_.includes(memberList, "MONTHLY")) {
    text = <span>ファンクラブサービス商品<br/>（購入の手続きへ）</span>
    style.backgroundColor = "var(--label-monthly)"
  } else if (_.includes(memberList, "PREMIUM")) {
    text = <span>ファンクラブサービス商品<br/>（購入の手続きへ）</span>
    style.backgroundColor = "var(--label-premium)"
  } else {
    text = <span>現在、販売を停止しています</span>
    style.backgroundColor = "var(--label-out)"
  }

  return (
    <button
      style={style}
      onClick={() => navigate(`/login/?continue=${encodeURIComponent(location.href)}`)}
    >{text}</button>
  )
}

const buttonCartFC = (item, note = '') => {
  const params = {
    hin: item.Hin,
    apiName: item.ecFanclub.name,
    apiKey: item.ecFanclub.key,
    apiSite: item.ecFanclub.site,
    apiUser: item.ecFanclub.user,
    register: item.ecFanclub.url,
  }
  let paramArray = []
  let paramString = ''
  for (const paramIndex in params) {
    paramArray.push(`${paramIndex}=${encodeURIComponent(params[paramIndex])}`)
  }
  paramString = paramArray.join('&')
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${CartImg})`,
    backgroundColor: "var(--theme-color)",
    backgroundSize: "18px",
  }

  return (
    <>
      <button
        style={style}
        onClick={() => navigate(`/loginfc/?${paramString}`)}
      >認証する</button>
      {
        note !== '' ? (
          <p className="comment error">{nl2br(note)}</p>
        ) : null
      }
    </>
  )
}

const checkLoginFc = (item) => {
  if (item.ecFanclub !== undefined && item.ecFanclub.name !== null) {
    const allowedMemberList = _.get(item, "ecCategory.member")
    let fcSession = getFcSession(item.ecFanclub.user)
    let fcMemberType = getFcMemberType(item.ecFanclub.user)
    if (fcSession !== undefined) {
      if ( // 年額会員待機、年額会員
        _.includes(allowedMemberList, "PREMIUM") &&
        _.includes([6,3], fcMemberType)
      ) {
        return 'typeMatch'
      } else if ( // 月額会員
        _.includes(allowedMemberList, "MONTHLY") &&
        _.includes([2], fcMemberType)
      ) {
        return 'typeMatch'
      } else if ( // 4:月額会員休眠、1:無料
        _.includes(allowedMemberList, "FREE") &&
        _.includes([1,4], fcMemberType)
      ) {
        return 'typeMatch'
      } else {
        return 'typeMissMatch'
      }
    } else {
      return 'needLogin'
    }
  } else {
    return 'notFc'
  }
}

const returnIfFc = (clickHandler, loading, item, location) => {
  const fcStatus = checkLoginFc(item)
  switch (fcStatus) {
    case 'typeMatch':
      return buttonCartOK(clickHandler, loading, item, location)
    case 'needLogin':
      return buttonCartFC(item)
    case 'typeMissMatch':
      return buttonCartFC(item, "会員種別を満たしていません。")
    default:
      return false
  }
}

const returnPreorderIfFc = (clickHandler, loading, item, location) => {
  const fcStatus = checkLoginFc(item)
  switch (fcStatus) {
    case 'typeMatch':
      return buttonCartPreOrder(item)
    case 'needLogin':
      return buttonCartFC(item)
    case 'typeMissMatch':
      return buttonCartFC(item, "会員種別を満たしていません。")
    default:
      return false
  }
}

const buttonCartOK = (clickHandler, loading, item, location) => {
  // const fcStatus = checkLoginFc(item)
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${CartImg})`,
    backgroundColor: "var(--theme-color)",
    backgroundSize: "18px",
  }

  return (
    <button style={style} onClick={clickHandler} disabled={loading}>カートに入れる</button>
  )

}

const buttonCartNG = (message = "カートに追加できません", note = "") => {
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${CartImg})`,
    backgroundSize: "18px",
  }

  return (
    <>
      <button style={style} className="error" disabled>{nl2br(message)}</button>
      <p className="comment error">{nl2br(note)}</p>
    </>
  )
}

const buttonCartUnauthorized = (message = "カートに追加できません") => {
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${CartImg})`,
    backgroundSize: "18px",
  }

  return (
    <>
      <button style={style} className="error" disabled>{nl2br(message)}</button>
      <p className="comment error">本商品は、ファンクラブサービスの加入が必要です<br/>ファンクラブサービスへの加入は<a href={process.env.FANCLUB_URL} target="_blank" rel="noreferrer">こちら</a>から</p>
    </>
  )
}

const buttonCartPreOrder = (item) => {
  const hin = _.get(item, "Hin")
  const style = {
    width: "290px",
    padding: "8px 30px",
    color: "white",
    fontSize: "16px",
    borderRadius: "24px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "15px center",
    backgroundImage: `url(${CartImg})`,
    backgroundColor: "var(--theme-color)",
    backgroundSize: "18px",
  }

  return (
    <>
      <button
        style={style}
        onClick={
          () => {
            deleteFcSession(item.ecFanclub.user)
            window.location.href = `${process.env.MODD_CART_URL}member/PreOrder.aspx?pcode=${hin}&scode=${process.env.MODD_SHOP_ID}`
          }
        }
      >申込みへ進む</button>
    </>
  )
}

export const canCheckout = (note) => {
  if (!note) return true

  switch (note) {
    case "※予約商品です。":
    case "※予約商品ですが、発売日に商品をお届けできない場合がございます。":
      return true
    default:
      return false
  }
}

export default ({item, productGroup, location, successCallback}) => {
  const [loading, setLoading] = useState(false)
  const [effectedCartButton, setEffectedCartButton] = useState(null)
  const [apiError, setApiError] = useState(null)
  const {session, memberType} = useContext(AuthContext)
  const {updateCartInfo} = useContext(CartContext)

  let initialSession = null

  const clickCartHandler = () => {
    deleteFcSession(item.ecFanclub.user)
    // セッション不正書き換え検知
    if (session !== getCookieSess()) {
      navigate("/login/")
      return
    }

    const params = {
      shopId: process.env.MODD_SHOP_ID,
      proCataNo: _.get(item, "Hin"),
      proQty: 1,
    }

    setLoading(true)
    ModdApi.get(`/AddItems`, {params: params})
    .then(res => {
      if (_.get(res.data, "ErrDetail")) {
        setApiError(_.get(res.data, "ErrDetail"))
        setEffectedCartButton(buttonCartNG())
      } else if (_.get(res.data, "ItemElements[0].Note")) {
        const errorText = _.get(res.data, "ItemElements[0].Note")

        // 特定の文言が含まれる場合はエラーとしない
        if (canCheckout(errorText)) {
          updateCartInfo(res.data)
          if (typeof successCallback === "function") {
            successCallback()
          }
        } else {
          setApiError(_.get(res.data, "ItemElements[0].Note"))
          setEffectedCartButton(buttonCartNG())
        }
      } else {
        updateCartInfo(res.data)
        if (typeof successCallback === "function") {
          successCallback()
        }
      }
      setLoading(false)
    })
    .catch(err => {
      console.error(err)
      setApiError("カート連携エラー")
      setEffectedCartButton(buttonCartNG())
    })
  }

  // MODDのステータス
  const initialCartButton = () => {
    if (item == null) return

    initialSession = session

    // MODD 状態
    switch (_.get(item, "Status")) {
      case 1:
        return buttonCartNG("完売しました")
      case 2:
        return buttonCartNG("現在、販売を\n中止しています")
    }

    // 現在時刻
    const nowDateTime = moment()

    // MODD 先行仮予約（受注商品）
    if (_.get(item, "ecSellingStatus") === "4") {
      // MODD 先行仮予約期間 開始
      const preBeginDateTime = moment(_.get(item, "PreFromDate"), "YYYYMMDDHHmm")
      if (preBeginDateTime.isValid()) {
        if (nowDateTime.isBefore(preBeginDateTime)) {
          return buttonCartNG(`${preBeginDateTime.format("YYYY/MM/DD HH:mm")} より\n受付開始いたします`)
        }
      }

      // MODD 先行仮予約期間 終了
      // 24時で終わる値（例：2020063024）の時は、23:59表記にする（例：2020/06/30 23:59）
      const preEnd = _.get(item, "PreToDate")
      const preEndDateTime = preEnd.slice(-2) === "24"
        ? moment(preEnd, "YYYYMMDDHHmm").minute(-1)
        : moment(preEnd, "YYYYMMDDHHmm")
      if (preEndDateTime.isValid()) {
        if (nowDateTime.isAfter(preEndDateTime)) {
          return buttonCartNG(`${preEndDateTime.format("YYYY/MM/DD HH:mm")} をもって\n受付終了いたしました`)
        }
      }

      // ログイン状態
      const memberList = _.get(item, "ecCategory.member")
      if (!_.isEmpty(session)) {
        const fcCheck = returnPreorderIfFc(clickCartHandler, loading, item, location)
        if (fcCheck) {
          return fcCheck
        }
        const ngMessage = "申込みできません"
        switch (memberType) {
          case 6: // 年額会員待機
            if (_.includes(memberList, "PREMIUM")) {
              return buttonCartPreOrder(item)
            } else {
              return buttonCartNG(ngMessage)
            }
          case 3: // 年額会員
            if (_.includes(memberList, "PREMIUM")) {
              return buttonCartPreOrder(item)
            } else {
              return buttonCartNG(ngMessage)
            }
          case 2: // 月額会員
            if (_.includes(memberList, "MONTHLY")) {
              return buttonCartPreOrder(item)
            } else {
              return buttonCartUnauthorized(ngMessage)
            }
          default: // 4:月額会員休眠、1:無料
            if (_.includes(memberList, "FREE")) {
              return buttonCartPreOrder(item)
            } else {
              if (_.includes(memberList, "MONTHLY")) {
                return buttonCartUnauthorized(ngMessage)
              } else if (_.includes(memberList, "PREMIUM")) {
                return buttonCartUnauthorized(ngMessage)
              } else {
                return buttonCartNG(ngMessage)
              }
            }
        }
      } else {
        return buttonLogin(memberList, location)
      }
    }
    // MODD 先行予約・仮予約対象外（通常商品・予約商品）
    else {
      // MODD 注文受付期間 開始
      const orderBeginDateTime = moment(_.get(item, "OrderDateFrom"), "YYYYMMDDHHmm")
      if (orderBeginDateTime.isValid()) {
        if (nowDateTime.isBefore(orderBeginDateTime)) {
          return buttonCartNG(`${orderBeginDateTime.format("YYYY/MM/DD HH:mm")} より\n販売開始いたします`)
        }
      }

      // MODD 発売日
      const releaseDateTime = moment(_.get(item, "ecReleaseDate"))
      if (releaseDateTime.isValid()) {
        if (nowDateTime.isBefore(releaseDateTime)) {
          if (nowDateTime.isAfter(orderBeginDateTime)) {
            // noop
            // 発売期間 ⊆ 注文受付期間 により注文受付期間中は非活性としない
          } else {
            return buttonCartNG(`${releaseDateTime.format("YYYY/MM/DD HH:mm")} より\n販売開始いたします`)
          }
        }
      }

      // MODD 注文受付期間 終了
      // 24時で終わる値（例：2020063024）の時は、23:59表記にする（例：2020/06/30 23:59）
      const orderEnd = _.get(item, "OrderDateTo")
      const orderEndDateTime = orderEnd.slice(-2) === "24"
        ? moment(orderEnd, "YYYYMMDDHHmm").minute(-1)
        : moment(orderEnd, "YYYYMMDDHHmm")
      if (orderEndDateTime.isValid()) {
        if (nowDateTime.isAfter(orderEndDateTime)) {
          return buttonCartNG(`${orderEndDateTime.format("YYYY/MM/DD HH:mm")} をもって\n販売終了いたしました`)
        }
      }

      // MODD 受注数制限
      if (_.get(item, "Limit") === 1 && _.get(item, "Stock") === 0) {
        return buttonCartNG("在庫確認中")
      }

      // ログイン状態
      const memberList = _.get(item, "ecCategory.member")
      if (!_.isEmpty(session)) {
        const fcCheck = returnIfFc(clickCartHandler, loading, item, location)
        if (fcCheck) {
          return fcCheck
        }
        switch (memberType) {
          case 6: // 年額会員待機
            if (_.includes(memberList, "PREMIUM")) {
              return buttonCartOK(clickCartHandler, loading, item, location)
            } else {
              return buttonCartNG()
            }
          case 3: // 年額会員
            if (_.includes(memberList, "PREMIUM")) {
              return buttonCartOK(clickCartHandler, loading, item, location)
            } else {
              return buttonCartNG()
            }
          case 2: // 月額会員
            if (_.includes(memberList, "MONTHLY")) {
              return buttonCartOK(clickCartHandler, loading, item, location)
            } else {
              return buttonCartUnauthorized()
            }
          default: // 4:月額会員休眠、1:無料
            if (_.includes(memberList, "FREE")) {
              return buttonCartOK(clickCartHandler, loading, item, location)
            } else {
              if (_.includes(memberList, "MONTHLY")) {
                return buttonCartUnauthorized()
              } else if (_.includes(memberList, "PREMIUM")) {
                return buttonCartUnauthorized()
              } else {
                return buttonCartNG()
              }
            }
        }
      } else {
        return buttonLogin(memberList, location)
      }
    }
  }

  return (
    <div>
      {(productGroup !== null && _.get(item, "ecItemName")) && (
        <p className="product-item-name">{item.ecItemName}</p>
      )}
      {(_.get(item, 'ecFanclub.name') !== '' && _.get(item, 'ecFanclub.name') !== null) && (
        <p style={{ marginBottom: '16px' }}>※こちらの商品は、「{_.get(item, 'ecFanclub.name')}」会員限定商品です。</p>
      )}
      {effectedCartButton ? (
        effectedCartButton
      ) : (
        initialCartButton()
      )}
      {apiError && <p className="comment error center">{apiError}</p>}
    </div>
  )
}